import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/exit",
    name: "Exit",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "exit" */ "../views/Exit.vue"),
  },
  {
    path: "/qctUserProtocal",
    name: "QctUserProtocal",
    component: () =>
      import(
        /* webpackChunkName: "qctServiceProtocal" */ "../views/QctUserProtocal.vue"
      ),
  },
  {
    path: "/qctPrivateProtocal",
    name: "QctPrivateProtocal",
    component: () =>
      import(
        /* webpackChunkName: "qctServiceProtocal" */ "../views/QctPrivateProtocal.vue"
      ),
  },
  {
    path: "/ctyxUserProtocal",
    name: "CtyxUserProtocal",
    component: () =>
      import(
        /* webpackChunkName: "qctServiceProtocal" */ "../views/CtyxUserProtocal.vue"
      ),
  },
  {
    path: "/ctyxPrivateProtocal",
    name: "CtyxPrivateProtocal",
    component: () =>
      import(
        /* webpackChunkName: "qctServiceProtocal" */ "../views/CtyxPrivateProtocal.vue"
      ),
  },
  {
    path: "/esopPrivateProtocal",
    name: "EsopPrivateProtocal",
    component: () =>
      import(
        /* webpackChunkName: "qctServiceProtocal" */ "../views/EsopPrivateProtocal.vue"
      ),
  },
  // {
  //   path: "/activity",
  //   name: "Activity",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "qctServiceProtocal" */ "../views/activity_20230303.vue"
  //     ),
  // },
  // {
  //   path: "/flvLive",
  //   name: "FlvLive",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "qctServiceProtocal" */ "../views/FlvLive.vue"
  //     ),
  // },
  // {
  //   path: "/shuangxiang",
  //   name: "Shuangxiang",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "qctServiceProtocal" */ "../views/Shuangxiang.vue"
  //     ),
  // },
  // {
  //   path: "/signTest",
  //   name: "signTest",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "qctServiceProtocal" */ "../views/SignTest.vue"
  //     ),
  // },
];

const router = new VueRouter({
  routes,
});

export default router;
